import http from "./http";

class ApiService {
  async getMetrics() {
    const res = await http.get("/metrics");
    return res.data;
  }

  async searchBooks(query = "") {
    const res = await http.get("/books/search", {
      params: { q: query },
    });
    return res.data;
  }

  async getLaunchedBooks(query = "") {
    const res = await http.get("/books/launched", {
      params: { q: query },
    });
    return res.data;
  }

  async getBookDetail(bookId) {
    const res = await http.get(`/books/${bookId}`);
    return res.data;
  }
}

export default new ApiService();

